export default __webpack_public_path__ + "static/media/figma.72908eec.svg";